import React from 'react';
import { iPhone17Models, colorOptions } from './data';

const ProductSelection = ({ formData, handleInputChange, errors }) => (
  <div className='form-section'>
    <div className='section-header'>
      <span className='section-icon'>📱</span>
      <h3>Product Selection</h3>
    </div>
    <div className='form-group'>
      <label>iPhone 17 Model</label>
      <div className='model-grid'>
        {iPhone17Models.map((model) => (
          <div
            key={model.id}
            className={`model-card ${
              formData.model === model.id ? 'selected' : ''
            }`}
            onClick={() =>
              handleInputChange({ target: { name: 'model', value: model.id } })
            }
          >
            <h4>{model.name}</h4>
            <p className='model-description'>Pre-order now for ₦25,000</p>
          </div>
        ))}
      </div>
      {errors.model && <span className='error-text'>{errors.model}</span>}
    </div>
    <div className='form-grid'>
      <div className='form-group'>
        <label htmlFor='color'>Color</label>
        <div className='color-options'>
          {colorOptions.map((color) => (
            <div
              key={color.id}
              className={`color-option ${
                formData.color === color.id ? 'selected' : ''
              }`}
              onClick={() =>
                handleInputChange({
                  target: { name: 'color', value: color.id },
                })
              }
            >
              <div className='color-swatch-wrapper'>
                <div
                  className='color-swatch'
                  style={{ backgroundColor: color.hex }}
                ></div>
              </div>
              <span className='color-name'>{color.name}</span>
            </div>
          ))}
        </div>
        {errors.color && <span className='error-text'>{errors.color}</span>}
      </div>
    </div>
    <div className='form-group'>
      <label>Quantity</label>
      <div className='quantity-options'>
        {[1, 2, 3, 4, 5].map((num) => (
          <div
            key={num}
            className={`quantity-option ${
              formData.quantity === num ? 'selected' : ''
            }`}
            onClick={() =>
              handleInputChange({ target: { name: 'quantity', value: num } })
            }
          >
            <span className='quantity-text'>
              {num} unit{num > 1 ? 's' : ''} (₦{(num * 25000).toLocaleString()})
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ProductSelection;
